import { createSelector } from "reselect";
import get from "lodash/get";
import { genericSelector } from "./appSettings";
import { simVerificationSelector } from "./forms/simVerification";
import { isIccIdValid, urlParam } from "utils/helpers";
import { getIccIdInUrlParam } from "utils/localStorage";

export const validateIccIdDomain = state => get(state, "api.validateIccId", {});

export const validateIccIdSelector = createSelector(
  validateIccIdDomain,
  validateIccId => get(validateIccId, "data", {})
);

export const iccIdErrorSelector = iccIdInUrl =>
  createSelector(
    validateIccIdDomain,
    genericSelector,
    simVerificationSelector,
    (validateIccId, generic, simVerificationForm) =>
      isIccIdValid(iccIdInUrl, generic, get(simVerificationForm, "icc_id", ""))
        ? get(validateIccId, "error", "")
        : iccIdInUrl
        ? "invalid_sim_card"
        : ""
  );

export const iccIdValidSelector = iccIdInUrl =>
  createSelector(
    genericSelector,
    simVerificationSelector,
    (generic, simVerificationForm) =>
      isIccIdValid(iccIdInUrl, generic, get(simVerificationForm, "icc_id", ""))
  );

export const iccIdValidOrderRefSelector = createSelector(
  validateIccIdSelector,
  validateIccId => get(validateIccId, "order.order_ref")
);

export const validateIccIdLoadingSelector = state =>
  get(state, "api.validateIccId.loading", false);

export const iccIdInUrlParamSelector = state => {
  const iccIdInUrlParam = get(state, "api.iccIdInUrlParam.data", {});
  const iccidparam =
    get(iccIdInUrlParam, "iccidparam") ||
    getIccIdInUrlParam() ||
    Boolean(urlParam("iccid"));

  return iccidparam ? { ...iccIdInUrlParam, iccidparam: true } : undefined;
};

export const makeSelectValidateIccId = () => validateIccIdSelector;

export const makeSelectIccIdError = iccIdErrorSelector;

export const makeSelectIccIdValid = iccIdValidSelector;

export const makeSelectIccIdDetails = () => validateIccIdSelector;

export const makeSelectValidateIccidStatus = () => validateIccIdLoadingSelector;

export const makeSelectIccIdInUrlParam = () => iccIdInUrlParamSelector;
